import { Menu } from '@/components/organisms/Menu/Menu'
import React, { useContext } from 'react'
import testi from '@/styles/prices/index.module.scss'
import Image from 'next/image'
import { Footer } from '@/components/organisms/Footer/Footer'
import { DataTable } from 'primereact/datatable'
import { price } from '@/data/dummy/price'
import { Column } from 'primereact/column'
import PriceCard from '@/components/moleculas/PriceCard/PriceCard'
import { HomeContext } from '@/context/guest/Home'
import PriceCardHome from '@/components/moleculas/PriceCardHome/PriceCardHome'

const data = [
  { name: 'Lectura de báscula', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Básculas de plataforma', lite: '-', simple: 'ILIMITADOS', truckdriver: 'ILIMITADOS' },
  { name: 'Pesaje camionero', lite: '-', simple: '-', truckdriver: '✓' },
  { name: 'Control de caja chica', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Compras a crédito', lite: '✓', simple: '✓', truckdriver: '✓' },
  { name: 'Ventas a crédito', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Inventarios', lite: '✓', simple: '✓', truckdriver: '✓' },
  { name: 'Usuarios', lite: '1', simple: '1', truckdriver: '1' },
  { name: 'Clientes/Proveedores', lite: '2', simple: 'ILIMITADOS', truckdriver: 'ILIMITADOS' },
  { name: 'Productos', lite: 'ILIMITADOS', simple: 'ILIMITADOS', truckdriver: 'ILIMITADOS' },
  { name: 'Movimientos al inventario', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Cuentas por pagar y cobrar', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Bancos', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Reportes', lite: '-', simple: '✓', truckdriver: '✓' },
  { name: 'Logo editable en ticket', lite: '-', simple: '✓', truckdriver: '-' },
  { name: 'Anuncios', lite: '✓', simple: '-', truckdriver: '' },
  { name: 'Tiempo de renovación', lite: 'MENSUAL', simple: 'SEGUN PLAN CONTRATADO', truckdriver: 'SEGUN PLAN CONTRATADO' }

]

const Prices = () => {
  const { subscriptions } = useContext(HomeContext)
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };
  const priceGrups = chunk(price, 3)

  return (
    <>
      <div style={{ backgroundColor: '#ffffff' }}>
        <div className={testi.body_section}>
          <div className={testi.image_container}>
            <Image
              src='/img/prices/precios.png'
              className={testi.logo1}
              alt='Picture of the author '
              width={701}
              height={534}
            />
          </div>
          <div className={testi.title_container}>
            <h2 className={testi.title1}>Planes y <br className={testi.hide_br} /> suscripciones</h2>
            <p className={testi.text}>Consulta los precios que ofrecemos, escoge el plan que más se adecúe a tus necesidades.</p>
          </div>
        </div>
        <div className={testi.membership_section}>
          {subscriptions.map((membership, index) => <PriceCardHome membership={membership} key={index} />)}
        </div>
        {/* {
           priceGrups.map((group, index) => (
             <div key={index} className={testi.body_section}>
               {
                   group.map((price, index) => (
                     <PriceCard key={index} {...price} />
                   ))
                }
             </div>))
          } */}
        <div className={testi.body_section}>
          <card className={testi.cardpresi}>
            <h1 className={testi.tabtitle}>TABLA COMPARATIVA</h1>
            <h2 className={testi.tabsubtitle}>Consulta los beneficios que tiene cada plan de sofware y elije el que más se acomode a tus necesidades</h2>
            <DataTable value={data} className={testi.center_table}>
              <Column field='name' header='' />
              <Column field='lite' header='LITE' />
              <Column field='simple' header='SENCILLO' />
              <Column field='truckdriver' header='CAMIONERO' />
            </DataTable>
          </card>
        </div>
      </div>
    </>
  )
}

export default Prices
